/* eslint-disable */
import { ReactNode } from "react";

import { useLocation } from "react-router-dom";

import { useAppSelector } from "../store/store";
import { Brand } from "../models/enum/Brand";
import Header from "./nav/Header";
import Footer from "./nav/Footer";

export const Layout = ({ children }: { children: ReactNode }) => {
  const { state } = useLocation();
  const { disableNavigation } = state || { disableNavigation: false };
  const brand = useAppSelector((state) => state.app.brand) ?? Brand.bbva;
  const tenantClassName = typeof brand === "string" ? brand : (Brand[brand] ?? Brand[Brand.bbva]);

  return (
    <div className={`tenant ${tenantClassName}`}>
      <Header />
      <main>
        <div className="container">{children}</div>
      </main>
      {!disableNavigation && <Footer />}
    </div>
  );
};
